import { ConnectedSecondaryMarketOrderBlotter } from '../Blotter';

export default ConnectedSecondaryMarketOrderBlotter;
